/**
 * Throttle utility
 *
 * @param {Function} fn - the function to throttle
 * @param {number} time - the throttle time
 * @returns {Function} the throttled function
 */
const throttle = (fn, time = 50) => {
  let timer = null

  const throttled = (...args) => {
    if (!timer) {
      timer = setTimeout(() => {
        fn(...args)
        timer = null
      }, time)
    }
  }

  throttled.cancel = () => {
    clearTimeout(timer)
    timer = null
  }

  return throttled
}

export default throttle
